import React from 'react';
import { Link } from 'react-router-dom';

const CorrectedPlatformHub = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black text-white p-6">
      <div className="max-w-7xl mx-auto mb-12 text-center">
        <h1 className="text-7xl font-bold mb-4 bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-500 bg-clip-text text-transparent">
          Aloha Nova's Universe
        </h1>
        <p className="text-3xl text-gray-400">Four Platforms, One Ecosystem</p>
      </div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Platform 1: Queen Supernova AI Agent */}
        <Link to="/dashboard" className="group relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-purple-500 to-pink-500 opacity-20 group-hover:opacity-30 transition-opacity" />
          <div className="relative bg-gray-900/80 border-2 border-purple-500 rounded-2xl p-8 transition-all transform group-hover:scale-105">
            <div className="text-8xl mb-6">👑</div>
            <h2 className="text-4xl font-bold mb-3 bg-gradient-to-r from-purple-400 to-pink-500 bg-clip-text text-transparent">
              Queen Supernova
            </h2>
            <p className="text-gray-300 text-xl mb-6">AI Agent with Voice & 3D Avatar</p>
            <ul className="space-y-2 text-gray-400">
              <li>• AI Chat & Voice Synthesis</li>
              <li>• 3D Realistic Avatars</li>
              <li>• Intelligent Conversations</li>
            </ul>
          </div>
        </Link>

        {/* Platform 2: Milkman's Twisted Oasis (Game) */}
        <Link to="/game" className="group relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-red-500 to-orange-500 opacity-20 group-hover:opacity-30 transition-opacity" />
          <div className="relative bg-gray-900/80 border-2 border-red-500 rounded-2xl p-8 transition-all transform group-hover:scale-105">
            <div className="text-8xl mb-6">🎮</div>
            <h2 className="text-4xl font-bold mb-3 bg-gradient-to-r from-red-500 to-orange-500 bg-clip-text text-transparent">
              Milkman's Twisted Oasis
            </h2>
            <p className="text-gray-300 text-xl mb-6">Vehicular Combat Game</p>
            <ul className="space-y-2 text-gray-400">
              <li>• Epic Battle Arenas</li>
              <li>• Skill Trees & Progression</li>
              <li>• Leaderboards & Rankings</li>
            </ul>
          </div>
        </Link>

        {/* Platform 3: Aloha Flix (Streaming) */}
        <Link to="/alohaflix" className="group relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-cyan-500 opacity-20 group-hover:opacity-30 transition-opacity" />
          <div className="relative bg-gray-900/80 border-2 border-blue-500 rounded-2xl p-8 transition-all transform group-hover:scale-105">
            <div className="text-8xl mb-6">📺</div>
            <h2 className="text-4xl font-bold mb-3 bg-gradient-to-r from-blue-500 to-cyan-500 bg-clip-text text-transparent">
              Aloha Flix
            </h2>
            <p className="text-gray-300 text-xl mb-6">All Streaming in One Hub</p>
            <ul className="space-y-2 text-gray-400">
              <li>• Movies, TV Shows & Music</li>
              <li>• 20+ Streaming Services</li>
              <li>• AI Recommendations</li>
            </ul>
          </div>
        </Link>

        {/* Platform 4: User Dashboard */}
        <Link to="/my-dashboard" className="group relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-green-500 to-emerald-500 opacity-20 group-hover:opacity-30 transition-opacity" />
          <div className="relative bg-gray-900/80 border-2 border-green-500 rounded-2xl p-8 transition-all transform group-hover:scale-105">
            <div className="text-8xl mb-6">📊</div>
            <h2 className="text-4xl font-bold mb-3 bg-gradient-to-r from-green-500 to-emerald-500 bg-clip-text text-transparent">
              My Dashboard
            </h2>
            <p className="text-gray-300 text-xl mb-6">Your Personal Hub</p>
            <ul className="space-y-2 text-gray-400">
              <li>• Account Management</li>
              <li>• Subscription & Billing</li>
              <li>• Usage Statistics</li>
            </ul>
          </div>
        </Link>
      </div>

      <div className="max-w-7xl mx-auto mt-12 text-center text-gray-500">
        <p>© 2025 Malcolm KH Lee III. All Rights Reserved.</p>
        <p className="mt-2">Aloha Nova's Universe • Powered by AI</p>
      </div>
    </div>
  );
};

export default CorrectedPlatformHub;